const LanguageSwitcherSetup = () => {
  const components = document.querySelectorAll('[data-component-language-switcher]');

  components.forEach((component) => {
    console.log(component);
  //   const toggle = component.querySelector('.toggle');
  //   let isOpen = false;
  //   const setupLanguages = () => {
  //     const currentLanguage = toggle.dataset.currentLanguage;
  //     const languages = component.querySelectorAll('a');
  //     languages.forEach((language) => {
  //       const isCurrent = language.href.includes(currentLanguage);
  //       if (isCurrent) {
  //         language.remove();
  //       }
  //     });
  //   };
  //   // setupLanguages();
  //
  //   const list = component.querySelector('.list');
  //
  //   const onMouseEnter = () => {
  //     isOpen = true;
  //     if (!toggle.classList.contains('is-active')) {
  //       toggle.classList.add('is-active');
  //     }
  //     gsap.to(list, {
  //       autoAlpha: 1,
  //       duration: 0.7,
  //       y: 0,
  //       ease: 'power3.out',
  //     });
  //   };
  //   const onMouseLeave = (isImmediate = false) => {
  //     isOpen = false;
  //     if (toggle.classList.contains('is-active')) {
  //       toggle.classList.remove('is-active');
  //     }
  //     gsap.to(list, {
  //       duration: isImmediate ? 0 : 0.5,
  //       autoAlpha: 0,
  //       y: -10,
  //       ease: 'power3.out',
  //     });
  //   };
  //
  //   const onToggle = (event) => {
  //     event.stopPropagation();
  //     if (isOpen) {
  //       onMouseLeave();
  //     } else {
  //       onMouseEnter();
  //     }
  //   };
  //
  //   if (!isTouchDevice) {
  //     component.addEventListener('mouseenter', () => onMouseEnter());
  //     component.addEventListener('mouseleave', () => onMouseLeave());
  //   } else {
  //     component.addEventListener('click', (event) => onToggle(event));
  //   }
  //   onMouseLeave(true);
  });
};
LanguageSwitcherSetup();